import React from 'react';
//import iconMedal from '../images/medal.png';

export const Loader = () => {
  return (
    <div className='loader__cointainer'>
     

      <h1 className='animated pulse infinite'>Cargando</h1>
    </div>
  );
};
